import { EntityService } from './EntityService';
import { IEntity } from '../types';

export class CLSecurityClearanceService extends EntityService<IEntity> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/CLSecurityClearances`);
    }
}